import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import Raven from 'raven-js';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getBundleRpc } from '../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
/**
 * Fetches product bundles with quantities from the MonBE API.
 * This does not use DFC (for now) due to the complexity of replacing
 * the extensive middleware/actions/selectors that are powering the plan builder.
 *
 * @param countryCode - The country code to fetch bundles for.
 * @param products - The products to fetch bundles for.
 * @returns The product bundles with quantities.
 */
export const getPublicProductBundlesWithQuantities = async ({
  countryCode,
  products
}) => {
  const response = await createRpcClientV2({
    hubHttpClient: noAuthHttp
  }).call(getBundleRpc, {
    request: {
      countryCode,
      products
    }
  }).catch(error => {
    Raven.captureException(error, {
      fingerprint: ['Failed to fetch bundles: v2 endpoint'],
      extra: {
        countryCode,
        products
      }
    });
    throw error;
  });
  return response === null || response === void 0 ? void 0 : response.products;
};